import Logout from '@app/Auth/Logout'

const Login = () => import('@app/Auth/Login')
const OrderLogin = () => import('@app/Auth/OrderLogin')
const PasswordRecoveryConfirm = () => import('@app/Auth/PasswordRecoveryConfirm')
const ResendTimer = () => import('@app/Auth/ResendTimer')
const SellerRegister = () => import('@app/Auth/Seller/Register')

export default function install(Vue) {
  Vue.component('Login', Login)
  Vue.component('Logout', Logout)
  Vue.component('PasswordRecoveryConfirm', PasswordRecoveryConfirm)
  Vue.component('OrderLogin', OrderLogin)
  Vue.component('SellerRegister', SellerRegister)
  Vue.component('ResendTimer', ResendTimer)
}
